export const OFFICE_GROUPS = [
  { value: "China Office", label: "China Office — Private", hint: "Salary payments stay in the private salary ledger only" },
  { value: "Other", label: "Other — Normal Accounting", hint: "Salary payments also post as Money Paid → Salary for Jatin" },
];

export const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const fmtMoney = (n) =>
  Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const currentPeriod = () => new Date().toISOString().slice(0, 7);

export const shiftPeriod = (period, delta) => {
  const [y, m] = period.split("-").map(Number);
  const d = new Date(Date.UTC(y, m - 1 + delta, 1));
  return d.toISOString().slice(0, 7);
};

export const periodLabel = (period) => {
  const [y, m] = period.split("-").map(Number);
  return `${MONTH_NAMES[m - 1]} ${y}`;
};

export const STATUS_TONE = {
  Due: "bg-amber-50 text-amber-700",
  "Partially Paid": "bg-blue-50 text-blue-700",
  Paid: "bg-emerald-50 text-emerald-700",
};

export const inputCls = "w-full h-11 px-3 border border-slate-300 rounded-lg text-sm outline-none bg-white";
